import React from 'react';
import { useDrag } from 'react-dnd';
import PropTypes from 'prop-types';

import Card from '../../../../../components/card-clip';
import { dragDropTypes } from '../../../../../constants/drag-drop-types';

import {
  Container,
} from './styles';

const CardClip = (props) => {
  const {
    testSessionNote,
    onClipPlay,
  } = props;

  const {
    status,
  } = testSessionNote;

  const enableDrag = status === 'processed';

  const [{ isDragging }, drag] = useDrag({
    item: { testSessionNote, type: dragDropTypes.CARD_CLIP },
    canDrag: enableDrag,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return (
    <Container
      ref={drag}
      isDragEnabled={enableDrag}
      isDragging={isDragging}
    >
      <Card
        testSessionNote={testSessionNote}
        onClipPlay={onClipPlay}
      />
    </Container>
  );
};

CardClip.propTypes = {
  testSessionNote: PropTypes.object.isRequired,
  onClipPlay: PropTypes.func.isRequired,
};

export default CardClip;
